import { useMytaverse } from '../../../../../providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();

  return {
    root: {},
    container: {
      width: 560,
      padding: '21px 36px 62px 36px',
    },
    content: {
      width: '100%',
      overflow: 'auto',

      '&::-webkit-scrollbar': {
        height: '5px',
        width: '5px',
      },

      '&::-webkit-scrollbar-track': {
        backgroundColor: '#D9D9D9',
        borderRadius: '2px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: appTheme.mainColor,
        borderRadius: '2px',
        boxShadow: 'unset',
      },

      '& form': {
        width: '100%',
      },
    },
  };
};
